import { COUNTRIES } from '@pray/shared/constants';

export const amountTypes = {
  default: 'default',
  custom: 'custom',
};

export const amountTiers = {
  tier1: { value: 'tier1', label: 'Gracious Giver' },
  tier2: { value: 'tier2', label: 'Giver' },
};

export const donationIntervals = {
  month: 'month',
  year: 'year',
  oneTime: 'once',
};

// Ministry Give PRD — flat preset table across all ministries on the
// generic /:handle/give page. Values in cents.
export const MINISTRY_GIVE_PRESETS = {
  once: [10000, 20000, 50000, 100000],
  month: [2500, 5000, 10000, 20000],
  year: [10000, 25000, 50000, 100000],
};

export const MINISTRY_GIVE_DEFAULT_CADENCE = donationIntervals.year;
// Index into MINISTRY_GIVE_PRESETS[cadence] of the tile that wears the
// "Most popular" badge AND is pre-selected on page load. Single source of
// truth so the badge and the default selection can never drift apart.
export const MINISTRY_GIVE_MOST_POPULAR_PRESET_INDEX = 1;
export const MINISTRY_GIVE_SOURCE = 'ministry-give-page';

export const donationTypes = {
  subscription: 'subscription',
  oneTime: 'one-time',
};

export const donationIntents = {
  paywall: 'paywall',
};

export const intervalAbbr = {
  day: 'day',
  week: 'wk',
  month: 'mo',
  year: 'yr',
};

export const prayerExperienceUserKey = 'onboarding-prayer_experience_level';

export const prayerExperinceOptions = [
  { value: 'new_to_prayer', label: 'I’m new to prayer' },
  { value: 'returning_to_prayer', label: 'I’m returning to prayer' },
  { value: 'pray_regularly', label: 'I pray regularly' },
  { value: 'never_miss_a_day_of_prayer', label: 'I never miss a day of prayer' },
];

export const [USA] = COUNTRIES;

export const defaultAmountType = amountTypes.default;
export const defaultAmountTier = amountTiers.tier1;
export const defaultInterval = donationIntervals.month;
export const defaultIntervalCount = 1;
export const defaultType = donationTypes.subscription;
export const defaultCountry = USA;
export const defaultPrayerExperienceOption = prayerExperinceOptions[0].value;

export const minMonthlyDonationAmount = 500;
export const minAnnuallyDonationAmount = 5000;

// Hardcoded values for copy update variation experiment
export const COPY_UPDATE_FUND_OVERRIDES = {
  amount_monthly_2: 500, // $5 in cents
  amount_yearly_2: 5000, // $50 in cents
  default_amount_monthly: 1000, // $10 in cents
  default_amount_yearly: 10000, // $100 in cents
};
